import axios from 'axios';
import {backendHost} from '../../../../store/config';

const getDailyList = (params) => {
    return axios.get(`${backendHost}/api/admin/finance-operation/list`, {params});
};

export {
    getDailyList
}